import { render, staticRenderFns } from "./QcUser115Dashboard.vue?vue&type=template&id=38c2dd56&scoped=true&"
import script from "./QcUser115Dashboard.vue?vue&type=script&lang=js&"
export * from "./QcUser115Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./QcUser115Dashboard.vue?vue&type=style&index=0&id=38c2dd56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c2dd56",
  null
  
)

export default component.exports